import { apiService } from './apiService';

/**
 * Selectable scene templates for room creation (multi-room-world Phase 2).
 * Backed by GET /api/scenes/available — id + display metadata only (the
 * ConfigJson-bearing CRUD stays on the moderator-gated admin route).
 */
export interface SceneTemplateOption {
  id: string;
  name: string;
  description: string;
  isDefault: boolean;
  // P4 catalog metadata (present on newer backends; optional for compatibility).
  category?: string;
  subCategory?: string;
  tags?: string | null;
  thumbnailUrl?: string | null;
  minPlayers?: number;
  blurb?: string | null;
  /** ISO timestamp; drives the "New" badge (< 14 days old). Optional — older backends omit it. */
  createdAt?: string | null;
}

class SceneTemplateService {
  async getAvailableScenes(
    mode: string = 'dating',
    category?: string,
  ): Promise<SceneTemplateOption[]> {
    const params = new URLSearchParams({ mode });
    if (category && category !== 'all') params.set('category', category);
    const response = await apiService.get<SceneTemplateOption[]>(
      `/api/scenes/available?${params.toString()}`,
    );
    if (response.error || !response.data) {
      return [];
    }
    return response.data;
  }
}

export const sceneTemplateService = new SceneTemplateService();
